<mat-card class="mb-25 tagus-card">
  <mat-card-header class="border-bottom">
    <h5 class="mb-0">{{ data.name }}</h5>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="mt-5">
      <div mat-dialog-content>
        <div class="row">
          <div class="col-12">
            <div class="tagus-form-group mb-12">
              <div class="tagus-form-group">
                <label class="d-block mb-12 fw-semibold gray-color"
                  >Senha <span>*</span></label
                >
                <mat-form-field>
                  <i class="ri-lock-fill"></i>
                  <mat-label>Senha</mat-label>
                  <input
                    matInput
                    type="password"
                    formControlName="password"
                    id="password"
                    style="text-transform: uppercase"
                  />
                  <mat-error *ngIf="hasError('password', 'required')"
                    >A senha é obrigatório</mat-error
                  >
                  <mat-error *ngIf="hasError('password', 'minlength')"
                    >A senha deve ter no mínimo 6 caracteres</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="tagus-form-group">
              <label class="d-block mb-12 fw-semibold gray-color"
                >Confirmar Senha <span>*</span></label
              >
              <mat-form-field>
                <i class="ri-lock-fill"></i>
                <mat-label>Confirmar Senha</mat-label>
                <input
                  matInput
                  type="password"
                  formControlName="confirmPassword"
                  id="confirmPassword"
                  style="text-transform: uppercase"
                />
                <mat-error *ngIf="hasError('confirmPassword', 'required')"
                  >A confirmação de senha é obrigatório</mat-error
                >
                <mat-error *ngIf="hasError('confirmPassword', 'minlength')"
                  >A confirmação de senha deve ter no mínimo 6
                  caracteres</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-12">
            <div class="alert alert-danger" *ngIf="messageError">
              {{ messageError }}
            </div>
            <div mat-dialog-actions>
              <button
                class="tagus"
                type="submit"
                mat-flat-button
                [disabled]="isLoading"
              >
                {{ !isLoading ? "Atualizar" : "Atualizando..." }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
